import { HbrCancel } from "../newComponents/Mycustomsvgicons";

const BlogImagesSelected = ({index, imageuri, clearImage}) => {
    return ( 
    <div className="blogimageselectedarrays" style={{position: "relative",height:"auto",width:"auto",marginTop:"20px"}}>
             {imageuri && <img src={URL.createObjectURL(imageuri)} alt=""/>} 
            
            <div style={{position:"absolute",top:"1px",right:"1px",borderRadius:"50%",padding:"2px",backgroundColor:"#FFFFFF30"}}>
                <HbrCancel width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>clearImage(index)}/>
            </div>
    </div>
     );
}
export default BlogImagesSelected;